import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { PRICE, INCLUDES, BONUSES } from '../constants/content';
import { PriceDisplay } from './PriceDisplay';
import { CtaButton } from './CtaButton';
export function PricingOffer() {
  return <section id="oferta" className="w-full bg-white py-14 sm:py-20" data-id="element-135" data-mp="1qwlqi0jamare">
      <div className="mx-auto max-w-3xl px-4" data-id="element-136" data-mp="2nll0bjzizklp">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-8 text-center" data-id="element-137" data-mp="2nj73p6p760c1">
          <h2 className="font-display text-3xl font-700 leading-tight text-ink sm:text-4xl" data-id="element-138" data-mp="135q097uhjnm9">
            Entonces Franco, ¿Cuánto Cuesta Esto?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-gray-700" data-id="element-139" data-mp="y8pteuptagu3">
            Si sumás lo que cuesta un contador por mes, lo que perdés en cajones
            mal calculados y lo que te clavan los proveedores por no saber
            comparar precios, esto se paga solo la primera semana.
          </p>
        </motion.div>

        {/* Offer card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="relative overflow-hidden rounded-3xl border-4 border-crimson bg-cream shadow-2xl" data-id="element-140" data-mp="18o15zi01q575">
          {/* Discount badge */}
          <div className="absolute -right-12 top-6 z-10 rotate-45 bg-crimson px-14 py-1.5 text-center text-sm font-700 uppercase tracking-wide text-white shadow-md" data-id="element-141" data-mp="b1bw6lz3qoaq">
            -70% OFF
          </div>

          <div className="grid gap-6 p-6 sm:p-8 md:grid-cols-2 md:items-center" data-id="element-142" data-mp="3t1xxvlb4ptph">
            {/* Mockup */}
            <div className="order-2 md:order-1" data-id="element-143" data-mp="3o9y3s9hqpv0t">
              <picture data-id="element-144" data-mp="3o94tiyjkondx">
                <source type="image/webp" srcSet="https://cdn.magicpatterns.com/uploads/n8U3rLJSdAsr1BoTB3NEJY/14-400.webp 400w, https://cdn.magicpatterns.com/uploads/qggzdpAhMKotXbbzTL4uzb/14-700.webp 700w" sizes="(max-width: 640px) 100vw, 700px" data-id="element-145" data-mp="3jbmqfos8l2du" />
                <img src="https://cdn.magicpatterns.com/uploads/gqmmS528H6RV4F2nirbs4h/14-700.jpg" srcSet="https://cdn.magicpatterns.com/uploads/t7gmQQM7F3y7mDWLBPsN6A/14-400.jpg 400w, https://cdn.magicpatterns.com/uploads/gqmmS528H6RV4F2nirbs4h/14-700.jpg 700w" sizes="(max-width: 640px) 100vw, 700px" alt="Cajón de pollo fresco del sistema Pollería Rentable 2026" width={800} height={800} loading="lazy" decoding="async" className="mx-auto w-full max-w-xs rounded-2xl object-cover shadow-lg ring-1 ring-black/5" data-id="element-146" data-mp="avt957q2zmvq" />
              </picture>
            </div>

            {/* Price */}
            <div className="order-1 text-center md:order-2 md:text-left" data-id="element-147" data-mp="1fuznzhm48m2u">
              <p className="mb-1 text-sm font-600 uppercase tracking-widest text-crimson" data-id="element-148" data-mp="1fwasxkrarzvj">
                Precio de hoy
              </p>

              <div className="mb-2 flex items-center justify-center gap-3 md:justify-start" data-id="element-149" data-mp="1oveeqwhumtdq">
                <PriceDisplay amount={PRICE.totalValue} strike className="text-xl font-500 text-gray-400" data-id="element-150" data-mp="1tv0p8y6alviu" />
              </div>

              <PriceDisplay amount={PRICE.today} className="block font-display text-6xl font-700 leading-none text-crimson sm:text-7xl" symbolClassName="mr-1 align-top text-4xl" data-id="element-151" data-mp="3vmdrffgvlpb7" />
              <p className="mt-2 text-sm text-gray-600" data-id="element-152" data-mp="1uvn0i59e0m5l">
                Valor total de{' '}
                <PriceDisplay amount={PRICE.totalValue} className="font-600" data-id="element-153" data-mp="1px20a5u4y2h5" />{' '}
                por menos de un tercio.
              </p>
            </div>
          </div>

          <div className="border-t border-black/10 p-6 sm:p-8" data-id="element-154" data-mp="1zvhuihoglruv">
            <CtaButton className="mb-4" data-id="element-155" data-mp="1zu6oscbgea14">COMPRAR AHORA</CtaButton>

            <a href="#" className="mb-5 block text-center text-sm font-600 text-crimson underline-offset-4 hover:underline" data-id="element-156" data-mp="1c788pfr8x43q">
              Montá Tu Pollería Rentable Hoy Mismo »
            </a>

            {/* Trust / payment */}
            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-600 text-gray-500" data-id="element-157" data-mp="1g7s7sovdqhsi">
              <span className="inline-flex items-center gap-1.5" data-id="element-158" data-mp="sh4xxy1wli3b">
                <LockIcon className="h-4 w-4 text-green-600" aria-hidden="true" data-id="element-159" data-mp="ohe0jbhvg3pt" />
                Pago 100% seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-160" data-mp="j3nss347d3ke">
                <ShieldCheckIcon className="h-4 w-4 text-green-600" aria-hidden="true" data-id="element-161" data-mp="j4yulxe3818v" />
                Garantía de 30 días
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-162" data-mp="9e458k5jolj7">
                <CreditCardIcon className="h-4 w-4 text-green-600" aria-hidden="true" data-id="element-163" data-mp="x4gmwmqldwmz" />
                Mercado Pago · Tarjetas
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-164" data-mp="n47nz157tx3w">
                <ZapIcon className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-165" data-mp="s42ciy1iqals" />
                Acceso instantáneo
              </span>
            </div>

            <p className="mt-4 text-center text-xs text-gray-500" data-id="element-166" data-mp="3cub7cm8baapv">
              Esto es un pago único. No hay cuotas mensuales.
            </p>
          </div>
        </motion.div>

        {/* Recap list */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-10 rounded-2xl bg-cream p-6 ring-1 ring-black/5" data-id="element-167" data-mp="1ec7visrqbudk">
          <h3 className="mb-4 text-center font-display text-2xl font-600 text-ink" data-id="element-168" data-mp="vmhzk2c8d2k2">
            Una Vez Más, Esto Es Todo Lo Que Vas A Recibir:
          </h3>

          {/* Value-stack visual */}
          <div className="mb-6 overflow-hidden rounded-2xl ring-1 ring-black/10" data-id="element-169" data-mp="loby1luc5yfq">
            <img src="https://cdn.magicpatterns.com/uploads/bBaV3yKLYtqXrHYmxPddTK/A_dramatic_high-converting_dig_Nano_Banana_2_89850.png" alt="Pollería Rentable 2026 — de $432.990 a solo $29.990, con todos los bonos incluidos" width={2560} height={1440} loading="lazy" decoding="async" className="w-full object-contain" data-id="element-170" data-mp="lqezr34upg0a" />
          </div>
          <ul className="space-y-2 text-sm text-gray-800" data-id="element-171" data-mp="2xcguh9v77tsy">
            {INCLUDES.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-172" data-mp="329h2hqblz6mp" data-mpi={i}>
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-crimson" data-id="element-173" data-mp="24n038fjbeiyb" />
                <span data-id="element-174" data-mp="24p4ejijjmk8m">
                  <strong className="font-700" data-id="element-175" data-mp="29lbfewx315jp">{item.title}</strong> —{' '}
                  {item.desc}
                  {item.value != null && <span className="ml-1 font-700 text-gold-dark" data-id="element-176" data-mp="2ejmov6jgte1e">
                      (<PriceDisplay amount={item.value} data-id="element-177" data-mp="2jl276qu9d6g3" /> de Valor)
                    </span>}
                </span>
              </li>)}
            {BONUSES.map(b => <li key={b.n} className="flex items-start gap-2" data-id="element-178" data-mp="3uxuyk0j4zsvm">
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" data-id="element-179" data-mp="jxkoic750o94" />
                <span data-id="element-180" data-mp="eyrbslzod1a0">
                  <strong className="font-700" data-id="element-181" data-mp="ez9fu4skwjsh">
                    Bono #{b.n}: {b.title}
                  </strong>{' '}
                  <span className="font-700 text-gold-dark" data-id="element-182" data-mp="top1x7h6011u">
                    (<PriceDisplay amount={b.value} data-id="element-183" data-mp="ox74gtecoilm" /> de Valor)
                  </span>
                </span>
              </li>)}
            <li className="flex items-start gap-2" data-id="element-184" data-mp="12n0rd66aossp">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-green-600" data-id="element-185" data-mp="ymqkzselc0db" />
              <span data-id="element-186" data-mp="yp30lywvlyn7">Garantía de 30 Días «Ámalo o Dejalo» sin riesgo</span>
            </li>
          </ul>

          <div className="mt-6 rounded-xl border-2 border-dashed border-crimson bg-white p-4 text-center" data-id="element-187" data-mp="17nf1quvdcetw">
            <p className="text-sm font-600 uppercase tracking-wide text-gray-500" data-id="element-188" data-mp="3edmmqe3x5x6d">
              Valor Total: <PriceDisplay amount={PRICE.totalValue} strike data-id="element-189" data-mp="39erwws7jb8cr" />
            </p>
            <p className="mt-1 text-base font-700 text-ink" data-id="element-190" data-mp="39gw4bk4n6phs">
              Conseguilo Hoy Por Un Pago Único De:
            </p>
            <PriceDisplay amount={PRICE.today} className="font-display text-5xl font-700 text-crimson" symbolClassName="mr-0.5 align-top text-2xl" data-id="element-191" data-mp="1tvkh8fmdfggx" />
          </div>

          <div className="mt-6" data-id="element-192" data-mp="1k590ttli3et5">
            <CtaButton data-id="element-193" data-mp="1k47q5q8ecuby">COMPRAR AHORA</CtaButton>
          </div>
          <p className="mt-3 text-center text-xs text-gray-500" data-id="element-194" data-mp="165zv5nux833f">
            Esto es un pago único. No hay cuotas mensuales ni costos ocultos. Me
            reservo el derecho de terminar este descuento en cualquier momento
            sin previo aviso después del 9 de agosto de 2026.
          </p>
        </motion.div>
      </div>
    </section>;
}